import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { keys } from 'lodash';
import Fa from 'react-fontawesome';

import { connect } from 'react-redux';
import Spinner from '../../../../components/spinner';
import sfLogo from '../../salesforce.png';
import mdLogo from '../../azure.png';
import hsLogo from '../../hubspot.png';
import styles from './styles.css';

import warningStyles from '../AuthenticatePage/styles.css';
import EnableApiInstruction from './EnableApiInstruction';
import SetupApplicationUserInstruction from './SetupApplicationUserInstructions';

// Import Actions
import { loginWithCodeRequest, clearLoginErrors } from '../../AuthActions';
import { getLoginErrors } from '../../AuthReducer';

function inIframe() {
  try {
    return window && window.self !== window.top;
  } catch (e) {
    return true;
  }
}

class ConnectPage extends Component {
  constructor(props) {
    const { location } = props;
    const query = queryString.parse(location.search);
    const { code, type, resource, refreshToken } = query;
    let hasOpener = false;
    const withinIframe = inIframe();
    try {
      hasOpener = typeof window !== 'undefined' && window.opener && typeof window.opener.loginCallback === 'function';
    } catch (e) {
      hasOpener = false;
    }
    super(props);
    this.state = {
      type,
      code,
      hasOpener,
      expand: false,
      withinIframe,
      resource,
      error: null,
      errorDescription: null,
      refreshToken,
      setupAzureModalShow: false,
      setupAzureModalParams: null,
    };
    if (hasOpener) {
      try {
        window.opener.loginCallback(query);
      } catch (e) {
        console.log(e);
      }
    }
    this.openLoginWindow = this.openLoginWindow.bind(this);
    this.buttonOpenFields = this.buttonOpenFields.bind(this);
  }

  componentDidMount() {
    const { code, hasOpener } = this.state;
    if (code && !hasOpener) {
      if (typeof window !== 'undefined' && window.opener && typeof window.opener.location !== 'undefined') {
        this.addConnectingMessage();
      } else {
        const { location } = this.props;
        const query = queryString.parse(location.search);
        this.doLogin(query);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { hasOpener } = this.state;
    const { location } = nextProps;
    const query = queryString.parse(location.search);
    const { code } = query;
    this.props.onConnecting(code || hasOpener);
  }

  buttonOpenFields() {
    this.props.dispatch(clearLoginErrors());
    this.setState({ error: null, errorDescription: null, code: null });
  }

  addConnectingMessage() {
    const { type, code, resource } = this.state;
    const windowHeight = window.opener.innerHeight || 900;
    const html = `
      <table style="border: 0; width: 100%; height: ${windowHeight}px">
        <tbody>
          <tr>
            <td style="text-align: center; vertical-align: middle">
              <p>connecting...</p>
              <p><a href="/signin?code=${code}&type=${type}&resource=${resource}" target="_blank">click here</a> if you are not redirected.</p>
            </td>
          </tr>
        </tbody>
      </table>
    `;

    window.opener.document.body.innerHTML = html;
    window.opener.focus();
    if (typeof window !== 'undefined' && window.opener && typeof window.opener.loginCallback === 'function') {
      window.opener.loginCallback();
    } else {
      window.opener.location.href = `/signin?code=${code}&type=${type}&resource=${resource}`;
    }
    window.close();
  }


  doLogin(params) {
    const { type, code } = params;
    const { hasOpener } = this.state;
    const { location } = this.props;
    const query = queryString.parse(location.search);
    const inviteCode = query.invite_code;
    if (code) {
      this.props.onLoading(true);
      this.props.dispatch(loginWithCodeRequest(type, { ...params, inviteCode })).then(
        (user) => {
          if (type === 'hubspotlogin' && user.is_synchronization_user) {
            this.openLoginWindowURL('/auth/hubspot/integration');
          }
          this.props.onLoading(false);
        },
        (e) => {
          if (hasOpener && e && !e.invite_code) {
            window.location.href = '/';
          }
          this.props.onLoading(false);
        },
      );
    }
  }

  openLoginWindowURL(url) {
    const w = 520;
    const h = 600;

    const top = ((window.top.outerHeight / 2) + window.top.screenY) - (h / 2);
    const left = ((window.top.outerWidth / 2) + window.top.screenX) - (w / 2);

    const loginWindow = window.open(url, 'Login', `scrollbars=yes,width=${w},height=${h},top=${top},left=${left}`);

    window.loginCallback = (params) => {
      const { type } = params;
      loginWindow.close();
      if (type === 'azure' || type === 'force' || type === 'hubspotlogin' || type === 'hubspotintegration') {
        this.setState({ type, code: params.code, error: params.error, errorDescription: params.errorDescription }, () => {
          this.doLogin(params);
        });
      } else if (type === 'setup-azure') {
        // `name`, `instanceUrl`, `tenantId`
        this.setState({ setupAzureModalShow: true, setupAzureModalParams: params });
      }
    };


    // Puts focus on the newWindow
    if (window.focus) {
      loginWindow.focus();
    }

    return false;
  }


  openLoginWindow(e) {
    e.preventDefault();
    let { target } = e;
    if (target.tagName !== 'A') {
      // they might have clicked on an inner tag
      target = target.parentNode;
    }
    const url = target.href;
    this.openLoginWindowURL(url);
  }


  renderMessage(type = 'force') {
    const { errors } = this.props;
    const errorKeys = keys(errors);
    if (errorKeys.length > 0) {
      const apiDisabled = errors !== null && errors.errorCode === 'API_CURRENTLY_DISABLED';
      if (apiDisabled) {
        return <EnableApiInstruction />;
      }
      if (errors.invite_code) {
        return this.renderErrorMessage('Sorry, this is an invite-only system.');
      }
      if (errors.message) {
        return this.renderErrorMessage(errors.message);
      }

      const { withinIframe } = this.state;
      const href = `/auth/${type}`;

      const props = {
        href,
        target: '_blank',
      };
      if (!withinIframe) {
        props.onClick = this.openLoginWindow;
        delete props.target;
      } else {
        // within an iframe
        props.href = `${href}?autoLogin=true`;
      }


      return (
        <div>
          <p>
            <a {...props}>
              Try again
            </a>
          </p>
        </div>
      );
    }
    return (
      <div>
        <Spinner />
        <p><em>one moment please</em></p>
      </div>
    );
  }

  renderForceButton() {
    const { disabled } = this.props;
    const { withinIframe } = this.state;
    const href = '/auth/force';
    const props = {
      href,
      disabled,
      className: `btn btn-primary btn-lg btn-block ${styles.btnSalesforce}`,
      target: '_blank',
    };
    if (!withinIframe) {
      props.onClick = this.openLoginWindow;
      delete props.target;
    } else {
      // within an iframe
      props.href = `${href}?autoLogin=true`;
      delete props.target;
    }
    return (
      <div>
        <a {...props}>
          {(!process.env.REACT_APP_AZURE_ENABLED && !process.env.REACT_APP_HUBSPOT_ENABLED) && <span>Login with&nbsp;</span>}
          <img alt="Salesforce" src={sfLogo} role="presentation" />
        </a>
      </div>
    );
  }

  renderAzureButton() {
    const { disabled } = this.props;
    const { withinIframe } = this.state;
    const href = '/auth/azure';
    const props = {
      href,
      disabled,
      className: `btn btn-default btn-lg btn-block ${styles.btnAzure}`,
      target: '_blank',
    };
    if (!withinIframe) {
      props.onClick = this.openLoginWindow;
      delete props.target;
    } else {
      // within an iframe
      props.href = `${href}?autoLogin=true`;
      delete props.target;
    }
    return (
      <div>
        <a {...props}>
          <img alt="Microsoft Dynamics" src={mdLogo} role="presentation" />
        </a>
      </div>
    );
  }

  renderHubSpotButton() {
    const { disabled, location } = this.props;
    const { withinIframe } = this.state;
    const query = queryString.parse(location.search);
    const inviteCode = query.invite_code;

    const href = `/auth/hubspot/login${inviteCode ? `?invite_code=${inviteCode}` : ''}`;
    const props = {
      href,
      disabled,
      className: `btn btn-default btn-lg btn-block ${styles.btnHubspot}`,
      target: '_blank',
    };
    if (!withinIframe) {
      props.onClick = this.openLoginWindow;
      delete props.target;
    } else {
      // within iframe
      props.href = `${href}?autoLogin=true`;
      delete props.target;
    }
    return (
      <div>
        <a {...props}>
          <img alt="HubSpot" src={hsLogo} role="presentation" />
        </a>
      </div>
    );
  }

  renderButtons() {
    let numOfButtons = 1; // default one salesforce button
    if (process.env.REACT_APP_AZURE_ENABLED) numOfButtons += 1;
    if (process.env.REACT_APP_HUBSPOT_ENABLED) numOfButtons += 1;

    let cls = '';
    if (numOfButtons === 2) {
      cls = styles.btns;
    } else if (numOfButtons > 2) {
      cls = styles.btns3;
    }

    return (
      <div className={cls}>
        {this.renderForceButton()}
        {process.env.REACT_APP_AZURE_ENABLED && this.renderAzureButton()}
        {process.env.REACT_APP_HUBSPOT_ENABLED && this.renderHubSpotButton()}
      </div>
    );
  }

  // content flash

  

  renderErrorMessage(errorDescription, error = null) {
    const { isDark } = this.props;
    return (
      <div className={`${isDark ? warningStyles.warningNight : warningStyles.warning} ${warningStyles.warningPanel} animated fadeIn`}>
        <Fa name="exclamation-triangle fa-3x" />
        <div className={`${warningStyles.warningText}`}>
          <div className={`${warningStyles.warningBold}`}>User validation failed.</div>
          <div>{errorDescription}</div>
          {error !== null && <div>Error code: <code>{error}</code></div>}
        </div>
        <span className={`pull-right ${isDark ? warningStyles.retryBtnNight : warningStyles.retryBtn}`} onClick={this.buttonOpenFields}>RETRY</span>
      </div>
    );
  }

  render() {
    const { hasOpener, error } = this.state;
    const fromServer = typeof window === 'undefined';
    const { location } = this.props;
    const query = queryString.parse(location.search);
    const { code, type } = query;
    if ((code && fromServer) || hasOpener) {
      return (
        <div>
          connecting...
        </div>
      );
    }
    if (error !== null && error !== undefined) {
      return this.renderErrorMessage(this.state.errorDescription, error);
    }
    return (
      <div>
        {(this.state.code !== null && this.state.code !== undefined) ? this.renderMessage(type) : this.renderButtons()}
        <SetupApplicationUserInstruction
          {...(this.state.setupAzureModalParams || {})}
          show={this.state.setupAzureModalShow}
          onClose={() => { this.setState({ setupAzureModalShow: false }); }}
          continue={() => { this.openLoginWindowURL('/auth/azure'); }}
        />
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    errors: getLoginErrors(state),
  };
}

ConnectPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    errorCode: PropTypes.string,
    invite_code: PropTypes.string,
    message: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  onLoading: PropTypes.func,
  onConnecting: PropTypes.func,
  disabled: PropTypes.bool,
  isDark: PropTypes.bool,
};

ConnectPage.defaultProps = {
  onLoading: () => {},
  onConnecting: () => {},
  disabled: false,
  isDark: false,
};

ConnectPage.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(ConnectPage);
